export enum EditSensorFormValuesNames {
  NAME = 'name',
}

export interface EditSensorFormValues {
  name: string;
}
